"use strict";

(function (global) {

  /**
   * Фабрика прикладных диалогов.
   *
   * @namespace WebAccess.factories.dialogs
   * @property {OBJECT_TYPE} WebAccess.factories.dialogs.contentType Тип содержимого фабрики
   * @since 5.2.0.1600
   * @example
   * WebAccess.factories.dialogs.getDialogByName('Actions', MODEL.FULL).done(function(dialog) {
   *   dialog.show();
   *   dialog.Init.done(function() {
   *     dialog.form.requisites['Строка'].setValue('Произвольное значение').disable();
   *     dialog.form.controls.tables['CTXGrid1'].addRow();
   *   });
   *   dialog.bind(WA.CMP.dialogs.FormDialog.EVENT.AFTER_ACTION, function(actionName, result) {
   *     console.log(actionName, result)
   *     return false; //Возвращая false мы запрещаем даилогу закрываться.
   *   });
   * });
   */

  var DialogsFactory = WA.FC.BaseFactory.extend({
    className: "DialogsFactory",
    //---------------------------------------------------------------------//    

    /**
     * Получить диалог по ИД.
     *
     * @method  WebAccess.factories.dialogs.getObjectByID
     * @param {number} id ИД объекта
     * @param {MODEL} [opt_modelType = MODEL.LINK] Тип модели.
     * @param {Object} opt_params Параметры диалога
     * @since 5.2.0.1600
     * @return {Deferred<Object>} Объект диалога.
     */
    getObjectByID: function (id, opt_modelType, opt_params) {
      if (isNaN(id)) WA.raise('ERR_AN_INVALID_PARAMETER_WAS_PASSED_TO_FUNCTION', id);
      return this._getObjectBy('ID', id, opt_modelType, opt_params);
    },
    //---------------------------------------------------------------------//

    /**
     * Получить диалог по имени.
     *
     * @method  WebAccess.factories.dialogs.getObjectByName
     * @param {string} name имя объекта
     * @param {MODEL} [opt_modelType = MODEL.LINK] Тип модели.
     * @param {Object} opt_params Параметры диалога
     * @since 5.2.0.1600
     * @return {Deferred<Object>} Объект диалога.
     */
    getObjectByName: function (name, opt_modelType, opt_params) {
      if (!_.isString(name)) WA.raise('ERR_AN_INVALID_PARAMETER_WAS_PASSED_TO_FUNCTION', name);
      return this._getObjectBy('Name', name, opt_modelType, opt_params);
    },
    //---------------------------------------------------------------------//

    /**
     * Получение диалог по ИД в кэше.
     *
     * @method  WebAccess.factories.dialogs.getObjectByInstanceID
     * @param {string} instanceID ИД диалога.
     * @param {MODEL} [opt_modelType = MODEL.LINK] Тип модели.
     * @since 5.2.0.1600
     * @return {Deferred<Object>} Объект диалога.
     */
    getObjectByInstanceID: function (instanceID, opt_modelType) {
      return this._getObjectBy('InstanceID', instanceID, opt_modelType);
    },
    //---------------------------------------------------------------------//

    /**
     * Получить диалога по ИД.
     *
     * @method  WebAccess.factories.dialogs.getDialogByID
     * @param {number} id ИД объекта
     * @param {MODEL} [opt_modelType = MODEL.LINK] Тип модели.
     * @param {Object} [opt_params] Параметры диалога
     * @since 5.2.0.1600
     * @return {Deferred<Object>} Объект диалога.
     */
    getDialogByID: function (id, opt_modelType, opt_params) {
      return this.getObjectByID.apply(this, arguments);
    },
    //---------------------------------------------------------------------//

    /**
     * Получить диалога по имени.
     *
     * @method  WebAccess.factories.dialogs.getDialogByName
     * @param {string} name имя объекта
     * @param {MODEL} [opt_modelType = MODEL.LINK] Тип модели.
     * @param {Object} opt_params Параметры диалога
     * @since 5.2.0.1600
     * @return {Deferred<Object>} Объект диалога.
     */
    getDialogByName: function (name, opt_modelType, opt_params) {
      return this.getObjectByName.apply(this, arguments);
    },
    //---------------------------------------------------------------------//


    /**
     * Получение диалога по ИД в кэше.
     *
     * @method  WebAccess.factories.dialogs.getDialogByInstanceID
     * @param {string} instanceID ИД диалога.
     * @param {MODEL} [opt_modelType = MODEL.LINK] Тип модели.
     * @since 5.2.0.1600
     * @return {Deferred<Object>} Объект диалога.
     */
    getDialogByInstanceID: function (instanceID, opt_modelType) {
      return this.getObjectByInstanceID.apply(this, arguments);
    },
    //---------------------------------------------------------------------//

    /**
     * Исходя из типа модели возвращает соответствующий объект.
     *
     * @method  WebAccess.factories.dialogs._handleModel
     * @param {Object} model модель объекта
     * @param {MODEL} [opt_modelType = MODEL.LINK] Тип модели.
     * @private
     * @return {Deferred<Object>} Объект системы.
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.2.0.1600
     */
    _handleModel: function (model, opt_modelType) {
      var me = this;

      var result;
      if (opt_modelType === MODEL.LINK) {
        var link = new WA.Link(model.ID, this.contentType, this.referenceName || null);
        link.isNew = (!!model.IsNew);
        result = link;
      } else {
        result = new WA.CMP.dialogs.FormDialog({}, model);
      }
      return result;
    },
    //---------------------------------------------------------------------//

    /**
     * Получить объект по указанному атрибуту
     *
     * @method  WebAccess.factories.dialogs._getObjectBy
     * @param {string} attrName имя атрибута
     * @param {string} attrValue значение атрибута
     * @param {MODEL} [opt_modelType = MODEL.LINK] Тип модели.
     * @param {Object} [opt_params] Параметры диалога
     * @private
     * @since 5.2.0.1600
     * @return {Deferred<Object>} Полученный объект.
     * @see https://api.jquery.com/category/deferred-object/
     */
    _getObjectBy: function (attrName, attrValue, opt_modelType, opt_params) {
      var me = this;
      opt_modelType = (!opt_modelType) ? MODEL.FULL : opt_modelType;

      // Может расширить, сократить или переопределить поля модельки.
      var createRequestModel = function (model) {
        var requestModel = {};
        requestModel.webAccessClientClassName = (model) ? model.className : '';
        switch (requestModel.webAccessClientClassName) {
          case 'Link':
            $.extend(requestModel, {
              id: model.id,
              type: model.type,
              referenceName: model.referenceName || ""
            });
            break;
          default:
            requestModel = model;
        }
        return requestModel;
      };

      opt_params = opt_params || {};
      var requestParams = _.mapObject(opt_params, function (value) {
        return createRequestModel(value);
      });

      var proxyCall = $.Deferred();

      var result;
      var query = { ObjectType: me.contentType, ReferenceName: me.referenceName || '', Mode: opt_modelType, Params: requestParams };
      query[attrName] = attrValue;

      WA.SRV.call('Dialogs.asmx/GetObjectBy' + attrName, query).done(function (model) {
        result = me._handleModel(model, opt_modelType);
        proxyCall.resolve(result);
      }).fail(function (err) {
        proxyCall.reject(err);
      });
      return proxyCall;
    }
    //---------------------------------------------------------------------//

  });
  //-----------------------------------------------------------------------//


  global.factories.dialogs = new DialogsFactory(OBJECT_TYPE.DIALOG);

})(window.WebAccess);